export enum OverlayShade {
  Default = 'default',
  Light = 'light',
}
